import styled from "styled-components";

export const Wrapper = styled.div`
  .content {
    display: grid;
    min-height: 100vh;

    .login-right-view {
      background: #ffffff;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
    }

    .login-right-inner {
      width: 100%;
      max-width: 760px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      min-height: 100%;
    }

    .login-left-view {
      min-height: 100vh;
      // display: none;
    }

    @media (min-width: 900px) {
      grid-template-columns: 1fr 1fr;

      .login-right-view {
        height: 100vh;
      }

      .login-left-view {
        position: sticky;
        top: 0;
        height: 100vh;
        overflow: hidden;
      }
    }

    @media (max-width: 899px) {
      .login-left-view {
        display: none;
        min-height: auto;
      }

      .login-right-view {
        overflow: visible;
        height: auto;
      }

      .login-right-inner {
        min-height: auto;
      }
    }
  }
`;

export const RightWrapper = styled.section`
  background: #ffffff;
  margin: auto;
  padding:  50px 0;
  width: 100%;
  @media (max-width: 1200px) {
    padding: 4rem 1rem;
  }
  Link {
    text-decoration: none;
  }
  .login-btn {
  }

  .rosabonLogo {
    display: block;
    margin-bottom: 1rem;
    @media (min-width: 900px) {
      display: none;
    }
  }

  .referal-link {
    padding-top: 20px;
  }
  h4 {
    font-style: normal;
    font-weight: 700;
    font-size: 33px;
    line-height: 40px;
    color: #222222;
    padding-bottom: 40px;
  }
  .login_input {
  }
  input[type="text"],
  input[type="email"],
  input[type="password"] {
    height: 54px;
    padding: 15px;
    border: 1.5px solid #e0e0e0;
    border-radius: 8px;
    padding-left: 20px;
    position: relative;
    font-weight: 500;
    font-size: 17px;
    line-height: 16px;
    position: relative;
    color: #333333;
  }
  .select-field {
    height: 54px;
    font-family: "Montserrat";
    border-left: 1.5px solid #e0e0e0 !important;
    border-top: 1.5px solid #e0e0e0 !important;
    border-bottom: 1.5px solid #e0e0e0 !important;
    border-right: 1px solid #eee;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 15px;
    letter-spacing: -0.01em;
    color: #242424;
    padding: 15px;
    background: #ffffff;
  }

  .select-user-field {
    height: 54px;
    font-family: "Montserrat";
    border: 1.5px solid #e0e0e0 !important;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 15px;
    letter-spacing: -0.01em;
    color: #242424;
    padding: 15px;
    background: #ffffff;
  }

  label {
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 21px;
    letter-spacing: -0.04em;
    color: #828282;
    padding-bottom: 15px;
    padding-left: 10px;
  }
  h3 {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 300;
    font-size: 13px;
    line-height: 16px;
    display: flex;
    align-items: center;
    letter-spacing: -0.02em;
    color: #e20d0d;
    padding-top: 12px;
  }

  .btn {
    height: 54px;
    padding: 15px 20px;
    border: 1.5px solid #e0e0e0;
    border-radius: 8px;
    font-weight: 500;
    font-size: 16px;
    font-family: "Montserrat";
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(28, 68, 141, 0.2);
    }

    &:disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .btn-primary {
    background: #1c448d;
    color: #ffffff;
    border: 1.5px solid #1c448d;

    &:hover:not(:disabled) {
      background: #133366;
      border-color: #133366;
    }
  }

  .btn-secondary {
    background: #ffffff;
    color: #333333;
    border: 1.5px solid #e0e0e0;

    &:hover:not(:disabled) {
      background: #f5f5f5;
      border-color: #999999;
    }
  }
`;

export const LoginInput = styled.div`
  label,
  span {
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 21px;
    letter-spacing: -0.04em;
    color: #828282;
  }
  label {
    padding-bottom: 7px;
    padding-left: 8px;
  }

  .form-check-label {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: #6d6d6d;
  }

  .phone-code {
    position: absolute;
    margin-top: 16px;
    margin-left: 20px;
    z-index: 10;
    font-weight: 500;
  }

  .phone-input {
    width: 100%;
    height: 54px;
    border: 1.5px solid #e0e0e0 !important;
    border-radius: 8px;
    padding: 15px 15px 15px 80px;
    position: relative;
    font-weight: 500;
    font-size: 17px;
    line-height: 16px;
    color: #333333;
    background: #ffffff !important;
  }

  .resend-btn {
    background: none;
    border: none;
    color: #1c448d;
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    padding: 0 8px;
    transition: all 0.2s ease;
    white-space: nowrap;

    &:hover:not(:disabled) {
      text-decoration: underline;
      color: #0f2550;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      color: #999999;
    }
  }
`;

export const LoginButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    font-style: normal;
    font-weight: 400;
    font-size: 17px;
    line-height: 21px;
    letter-spacing: -0.04em;
    color: #333333;
    margin-top: 15px;
  }
  span {
    color: rgba(28, 68, 141, 1);
  }

  /* Responsive button styles */
  .text-center {
    display: flex;
    gap: 10px;
    justify-content: center;
    flex-wrap: wrap;

    button {
      flex: 1 1 auto;
      min-width: 120px;

      @media (max-width: 768px) {
        flex: 1 1 45%;
      }

      @media (max-width: 480px) {
        flex: 1 1 100%;
      }
    }
  }
`;

export const ProgressIndicator = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #e0e0e0;
`;

export const ProgressStep = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  flex: 1;

  .step-number {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    background: ${(props) => (props.active ? "#1c448d" : "#f0f0f0")};
    color: ${(props) => (props.active ? "#ffffff" : "#999999")};
    border: 2px solid ${(props) => (props.completed ? "#1c448d" : "#e0e0e0")};
    transition: all 0.3s ease;

    ${(props) =>
    props.completed &&
    `
      background: #1c448d;
      color: #ffffff;
    `}
  }

  .step-title {
    font-size: 11px;
    font-weight: 500;
    color: ${(props) => (props.active || props.completed ? "#1c448d" : "#999999")};
    text-align: center;
    white-space: nowrap;
  }
`;
